import { useMutation, useQueryClient } from '@tanstack/react-query'
import { annotateCompanyFile } from 'api/company/annotateCompanyFile'
import { companyFileFieldsKey, companyFilesKey } from './keys'

export function useAnnotateCompanyFileMutation(companyId: number) {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: ({
      fileId,
      schema,
    }: {
      fileId: number
      schema: Record<string, unknown>
    }) => annotateCompanyFile(companyId, fileId, schema),
    onSuccess: async (_data, variables) => {
      await queryClient.invalidateQueries({
        queryKey: companyFilesKey(companyId),
      })
      await queryClient.invalidateQueries({
        queryKey: companyFileFieldsKey(companyId, variables.fileId),
      })
    },
  })
}
